import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setRefetch,
  setRefetchKey,
} from "../../../../../features/global/globalSlice";
import { Tabs } from "antd";
import BreadCrumb from "../../../../../layout/BreadCrumb";
import Information from "./information/Information";
import MembersTable from "./members/MembersTable";
import ProductionDataTable from "./production-data/ProductionDataTable"; 
import FarmInputTable from "./farm-input/FarmInputTable";
import DataSchemeTable from "./data-schemes/DataSchemeTable";

function PrivateIwuaViewList() {
  const dispatch = useDispatch();
  const [active, setactive] = useState("1"); 
  const {iwuaPrivateObj} = useSelector((state)=>state.obj)
  const [showVerify, setShowVerify] = useState(false);
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["privateSchemes"],
  }));
  async function refetching(activeKey) {
    setShowVerify(false)
    setactive(activeKey);
    await dispatch(setRefetch());
    await dispatch(setRefetchKey(activeKey));
  }
  const [memberAdd,setMemberAdd] =  useState(false)

  const tabConfigurations = [
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Information</span>
        </span>
      ),
      key: "1",
      children: <Information />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className=" " >Members</span>
        </span>
      ),
      key: "2",
      children:  <MembersTable  /> 
    },
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Data Requests</span>
        </span>
      ),
      key: "3",
      children: <DataSchemeTable/>,
    },
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Production Data</span>
        </span>
      ),
      key: "4",
      children: <ProductionDataTable showVerify={showVerify} setShowVerify={setShowVerify} />,
    },
    {
      label: (
        <span className="flex items-center">
          <span className=" ">Farm Inputs</span>
        </span>
      ),
      key: "5",
      children: <FarmInputTable/>,
    },
 
  ];
  return (
    <>
      <BreadCrumb
        breadcrumbs={[
          { title: "Schemes Overview", path: "/scheme/scheme-overview" },
          { title: "Private Scheme", path: "/scheme/private-scheme" },
          { title: `Scheme ${activeObjSchemes?.schName} View`, path: "/scheme/private-scheme-view" },
          { title: "IWUA List", path: "/scheme/private/iwua-list" },
          { title: `View ${iwuaPrivateObj?.instName}` },
        ]}
      />
      
      <div className="white_card mt-[2.41rem] flex-1 min-h-[80vh]">
        <div className="form-add-h">{iwuaPrivateObj?.instName} IWUA</div>
        <Tabs
          items={tabConfigurations}
          defaultActiveKey="1"
          activeKey={active}
          onChange={refetching}
          className="mt-[1.75rem] iwua-tab-holder  iwua-tabs-btn iwua-tabs-btn-inactive iwua-ink-bar iwua-nav-list "
        />
      </div>
    </>
  );
}

export default PrivateIwuaViewList;
